export enum GroupChannelType {
  blocked = 'blocked',
  bot = 'bot',
  connection = 'connection',
  connectionRequest = 'connection-request',
  deal = 'deal',
  dealRequest = 'deal-request',
}

export enum ConversationType {
  dm = 'dm',
  groupChat = 'group-chat',
}
